// The label store of the filmstrip-previews workspace (pt-BR pack, ruling R-21).
//
// The English SOURCE of the `filmstrip_module` catalog section, keyed by full dotted key. The block between
// the markers is the same map as the section of `P/src/Fotomania/Labels/ModuleLabels.php`: the parity test
// `studio/tooling/i18n/module-labels.test.mjs` fails when the two differ, key for key. The Portuguese
// reaches this bundle through its own bootstrap channel (see `setModuleFeed`); a missing or malformed
// feed leaves the English source. This module never imports the components' label store.
import { createModuleLabels } from '../../shared/module-labels';

// BEGIN MODULE SOURCE
const SOURCE: Record<string, string> = {
  "filmstrip_module.pending_photos": "Pending photos in this unit",
  "filmstrip_module.view_number": "View %number",
};
// END MODULE SOURCE

export const MODULE_SECTION = 'filmstrip_module';
const labels = createModuleLabels(MODULE_SECTION, SOURCE);
/** Resolve a key of this module's section at call time (never at module load: the feed arrives at boot). */
export const t = labels.t;
/** Replace the runtime layer from the module's channel (a missing or malformed feed keeps the English source). */
export const setModuleFeed = labels.setFeed;
/** The English source map (the identity test and the parity test read it). */
export const MODULE_SOURCE: Readonly<Record<string, string>> = SOURCE;
